import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { InputDropdown, MultiLevelDropdown, InputAdornment, Chip, Icon } from 'bonfire-kindling';
import _isEqual from 'lodash/isEqual';
import _truncate from 'lodash/truncate';
import useOverloadedInputDropdown from '../hooks/useOverloadedInputDropdown';

const FilterByOpportunityType = ({ onChange, values, availableValues }) => {
  const { t } = useTranslation();

  const tree = useMemo(
    () => [
      {
        children: availableValues.map(type => ({ label: type, value: type })),
        label: t('opportunities.filters.opportunity_type_all'),
        value: '',
      },
    ],
    [availableValues, t]
  );

  const inputValueFormatted = useMemo(
    () =>
      values.length === availableValues.length
        ? t('opportunities.filters.opportunity_type_all')
        : _truncate(values.join(', '), { length: 25, separator: /,? +/ }),
    [t, values, availableValues]
  );

  const { overloadedCount } = useOverloadedInputDropdown(inputValueFormatted, values);

  return (
    <InputDropdown
      label={t('opportunities.filters.opportunity_type')}
      value={inputValueFormatted}
      TextFieldProps={{
        placeholder: t('opportunities.filters.opportunity_type_all'),
        InputProps: {
          endAdornment: (
            <InputAdornment position="end">
              {overloadedCount > 0 && (
                <Chip size="small" label={`+${overloadedCount}`} color="primary" />
              )}
              <Icon iconName="caret-down" mr={1} size="small" />
            </InputAdornment>
          ),
        },
      }}
    >
      <MultiLevelDropdown
        initialChecked={availableValues}
        hideExpand
        checked={values}
        disableReset
        disableSearch
        nodes={tree}
        onCheck={checked => {
          // `onCheck` is called everytime you open the dropdown for some reason which
          // causes a network request to be triggered since a new object is created in
          // state when calling `onChange`. This mitigates that by checking if the values
          // actually changed before calling `onChange`.
          if (!_isEqual(checked, values)) {
            onChange(checked);
          }
        }}
      />
    </InputDropdown>
  );
};

export default FilterByOpportunityType;
